module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaBAMAAABFrWFOAAAAJFBMVEUre8sre8sre8sre8vt8POkxOQzgM3l6/HM3Ox0p9pLj9Ksyea0w6TJAAAAA3RSTlPmSklSjzZ3AAAAPUlEQVQY02NQMIYCJgZmGNOAwRgOqMQ0TYYzTboQTPfJUKaLi4trMpzpshldFKEWYQLCXModiex5ARiTEQBgsjZ6irDZfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_after.png
// module id = +VDq
// module chunks = 9